export default {
    name: 'Events'
}
